import { and } from '@lumapps/utils/function/predicate/and';
import { HTMLElementConvertOption } from '@lumapps/wrex/serialization/html/fromHTML/types';
import { matchAttribute, matchNode } from '@lumapps/wrex/serialization/html/fromHTML/utils';

import { CLASSNAME, INFO_PANEL, INFO_PANEL_KINDS } from '../../../constants';
import { InfoPanelKind } from '../../../types';
import { createInfoPanel } from '../../../utils/createInfoPanel';

type ElementTypes = typeof INFO_PANEL;

/**
 * Element convert options.
 *
 * Warning: the order of these options does matter!
 */
export const ELEMENTS: { [Element in ElementTypes]: HTMLElementConvertOption<Element> } = {
    /**
     * Convert an HTML info panel (`<div class="wrex-content-info-panel" data-kind="…">`) into a slate info panel.
     */
    [INFO_PANEL]: {
        type: INFO_PANEL,
        test: and(matchNode({ tagName: 'div' }), matchAttribute('className', new RegExp(CLASSNAME))),
        transform: ({ properties }: any, children: any) => {
            const rawKind = properties?.dataKind;
            // Pass children through: the info panel normalizer wraps any loose text into paragraphs.
            const node = createInfoPanel(children);
            return INFO_PANEL_KINDS.includes(rawKind) ? { ...node, kind: rawKind as InfoPanelKind } : node;
        },
    },
};
